import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseDisclaimersProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `Disclaimers/${props.franchiseDisclaimerId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        const dataSubmit = {
            "Message" : props.message,
            "DisclaimerPositionId" : props.disclaimerPositionId,
            "FranchiseIds": [props.franchiseId]
        }
        await execute({ scope: 'create', url: `Disclaimers`, method: 'POST', payload: dataSubmit, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        const dataSubmit = {
            "Message" : props.message,
            "DisclaimerPositionId" : props.disclaimerPositionId,
            "FranchiseIds": [props.franchiseId]
        }
        await execute({ scope: 'update', url: `Disclaimers/${props.franchiseDisclaimerId}`, method: 'PUT', payload: dataSubmit, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `Disclaimers/Franchise/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `Disclaimers/${props.franchiseDisclaimerId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseDisclaimersStore = () => React.useContext(Context);
